module.exports = __webpack_public_path__ + "img/appstore.54ecc153.svg";